/**
 * Loads Microsoft Clarity session-replay snippet.
 * No-op when:
 *   - projectId is empty (env vars not wired yet)
 *   - hostname is localhost (dev noise)
 *   - script has already been loaded
 */
export function bootstrapClarity(projectId: string): void {
  if (!projectId) return;
  if (typeof window === 'undefined') return;
  if (/^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname)) return;
  if ((window as unknown as { clarity?: unknown }).clarity) return;

  // Standard Clarity snippet, TS-friendly.
  (function (c: Window, l: Document, a: string, r: string, i: string) {
    const win = c as unknown as { [key: string]: unknown };
    win[a] =
      win[a] ||
      function (...args: unknown[]) {
        (win[a] as { q: unknown[][] }).q = (win[a] as { q?: unknown[][] }).q || [];
        (win[a] as { q: unknown[][] }).q.push(args);
      };
    const t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = 'https://www.clarity.ms/tag/' + i;
    const y = l.getElementsByTagName(r)[0];
    y.parentNode?.insertBefore(t, y);
  })(window, document, 'clarity', 'script', projectId);
}
